import React from 'react';
import SplitContainer from '@zippytech/react-toolkit/SplitContainer'
import { connect } from 'react-redux';
import ContentBrowserPane from './BrowserPane/ContentBrowserPaneForCommanTable';


import { Route, withRouter } from 'react-router-dom';
import ContentList from './DesignerPane/ContentListReactTable'
import AddContent from './DesignerPane/AddContent'
import './styles.css';
import { HelpComponent } from "../../common/HelpComponent";
import { dispatch } from '@rematch/core';
import ContentDetailPage from './DesignerPane/ContentDetailPage';

import IndexResourcePane from './ResourcePane/index'
import ReactResizeDetector from 'react-resize-detector';

class ContentManager extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            splitAt: "60%",
            browserPaneSplit: "25%",
            collapsedResourcePaneIndex: null
        }
        this.onResizeResource = this.onResizeResource.bind(this)
        this.landingMessage = 'Please select category from left panel'
    }

    componentWillMount() {

        let userid = this.props.user._id.toString();
        let payload = {};
        payload.organizationId = this.props.selectedOrganisation.id;
        payload.accountId = this.props.match.params.accountId;
        payload.userid = userid;

        dispatch.content.getCategoryAsync(payload);
        dispatch.categories.getAllCategories({ organizationId: this.props.match.params.workspaceId })
        dispatch.app.setCurrentContext("content");
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        dispatch.content.splitAt(null);
        dispatch.content.openResourcePane(null);
    //     let access = this.props.routeParams.status === "knowledgeBank" ? "Private" :
    //         this.props.routeParams.status === "publicKnowledgeBank" ? "Public" : "all"

    //    dispatch.categories.getCategoryTreeByAccess({ "accountId": this.props.match.params.accountId, access: access });
    }

    componentDidMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        document.addEventListener("keydown", this.keyPress, false);
        dispatch.content.setContentComponentMounted(true);
    }

    onResizeResource(width, height) {

        let windowHeight = window.innerHeight;
        let designerDimension = {
            width: width,
            windowHeight: windowHeight,
            height: height
        }
        dispatch.initiatives.setDesignerDimension(designerDimension);


        if (this.props.setUniqueId) {
            const initiativeCardElement = document.getElementById(this.props.setUniqueId);
            if (initiativeCardElement) {
                setTimeout(() => {
                    initiativeCardElement.scrollIntoView({ block: 'center', inline: "nearest" });
                }, 100);
            }
        }
    }

    keyPress = async (e) => {
        if (e.keyCode === 27) {
            await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
            await dispatch.content.openResourcePane(null);
            await dispatch.content.setSelectedContent({});

        }
    }

    render() {

        return (
            <SplitContainer
                orientation="vertical"
                minSize="10%"
                maxSize={['50%', null]}
                fillSides={[true, true]}
                collapsible={[true, false]}
                defaultSplitAt="25%"
                resizeProxy={true}
                collapsedIndex={this.state.collapsedBrowserPaneIndex}
                splitAt={this.state.browserPaneSplit}
                onResize={(browserPaneSplit) => {
                    if (Number(browserPaneSplit.replace("%", "")) < 11) {
                        this.setState({ collapsedBrowserPaneIndex: 0 })
                    } else {
                        this.setState({ browserPaneSplit })
                    }
                }}
                onExpand={() => {
                    this.setState({
                        collapsedBrowserPaneIndex: null,
                        browserPaneSplit: "25%"
                    })
                }}
                onCollapse={(index) => {
                    this.setState({
                        collapsedBrowserPaneIndex: index,
                        browserPaneSplit: "25%"
                    })
                }}

            >

                <SplitContainer
                    orientation="horizontal"
                    minSize="10%"
                    collapsible={[false, true]}
                    defaultSplitAt="75%"
                >
                    <SplitContainer.Side className="Split-BrowserPane">
                        <ContentBrowserPane {...this.props} name="Content Development Library Browser Window" />
                    </SplitContainer.Side>

                    <SplitContainer.Side className="Split-HelpPane">
                        <HelpComponent />
                    </SplitContainer.Side>
                </SplitContainer>

                <SplitContainer
                    orientation="horizontal"
                    splitAt={this.props.resourcePaneFlag && this.props.splitAtSize ? this.props.splitAtSize : "100%"}
                    locked={this.props.resourcePaneFlag === null}
                    minSize={["0%", "0%"]}
                    maxSize={[null, '81%']}
                    collapsible={[true, true]}
                    fillSides={[true, true]}
                    resizeProxy={true}
                    collapsedIndex={this.props.collapsedResourcePaneIndexTemp === 1 || this.props.collapsedResourcePaneIndexTemp === 0 ? this.state.collapsedResourcePaneIndex : this.props.collapsedResourcePaneIndexTemp}
                    onResize={(splitAt) => {
                        if (Number(splitAt.replace("%", "")) < 30) {
                            this.setState({ collapsedResourcePaneIndex: 0 })
                            dispatch.app.setCollapsedResourcePaneIndexTemp(0)
                        } else if (Number(splitAt.replace("%", "")) > 80) {
                            this.setState({ collapsedResourcePaneIndex: 1 })
                            dispatch.app.setCollapsedResourcePaneIndexTemp(1)
                        } else {
                            this.setState({ collapsedResourcePaneIndex: null })
                            dispatch.content.splitAt(splitAt)
                            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                        }
                    }}
                    onExpand={() => {
                        this.setState({ collapsedResourcePaneIndex: null })
                        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                        dispatch.content.splitAt("60%")
                    }}
                    onCollapse={(index) => {
                        this.setState({ collapsedResourcePaneIndex: index })
                        dispatch.app.setCollapsedResourcePaneIndexTemp(index)
                    }}
                    onKeyDown={this.keyPress}
                >
                    <SplitContainer.Side className="Split-DesignerPane">
                        <div>
                            <Route exact path="/app/:accountId/_ws/:workspaceId/_ct" render={() => (<ContentList  {...this.props} name="Content List" />)} />
                            <Route exact path="/app/:accountId/_ws/:workspaceId/_ct/status/:status" render={() => (<ContentList  {...this.props} name="Content List" />)} />
                            <Route exact path="/app/:accountId/_ws/:workspaceId/_ct/status/:status/:baseCategory" render={() => (<ContentList {...this.props} name="Content List" />)} />
                            <Route exact path="/app/:accountId/_ws/:workspaceId/_ct/status/:status/:baseCategory/:category" render={() => (<ContentList {...this.props} name="Content List" />)} />
                            <Route exact path="/app/:accountId/_ws/:workspaceId/_ct/status/:status/:baseCategory/:category/:subCategory" render={() => (<ContentList {...this.props} name="Content List" />)} />
                            <Route exact path="/app/:accountId/_ws/:workspaceId/_ct/add" render={() => (<AddContent  {...this.props} categoriesArr={this.props.categoriesArr} name="Add Content" />)} />
                            <Route exact path="/app/:accountId/_ws/:workspaceId/_ct/edit/:contentId" render={() => (<AddContent  {...this.props} categoriesArr={this.props.categoriesArr} name="Add Content" />)} />
                            <Route exact path="/app/:accountId/_ws/:workspaceId/_ct/edit/:status/:contentId" render={() => (<AddContent  {...this.props} categoriesArr={this.props.categoriesArr} name="Add Content" />)} />
                            <Route exact path="/app/:accountId/_ws/:workspaceId/_ct/details/:contentId" render={() => (<ContentDetailPage  {...this.props} categoriesArr={this.props.categoriesArr} name="Content Detail" />)} />
                        </div>

                    </SplitContainer.Side>
                    <SplitContainer.Side className="Split-ResourcePane"  >
                        <ReactResizeDetector handleWidth handleHeight onResize={this.onResizeResource}>
                            <IndexResourcePane {...this.props} user={this.props.user} />
                        </ReactResizeDetector>
                    </SplitContainer.Side>
                </SplitContainer>
            </SplitContainer>
        )
    }
}

function mapStateToProps(state) {
    return {
        treeNode: state.content.treeNode,
        user: state.app.user,
        routeParams: state.app.routeParams,
        selectedOrganisation: state.app.selectedOrganisation,
        showLandingPageFlag: state.content.showLandingPageFlag,
        categoryList: state.content.categoryList,
        categoriesArr: state.content.categoriesArr,
        subCategoriesArr: state.content.subCategoriesArr,
        categoryTree: state.lifeCycle.categoryTree,
        categoryPublicTree: state.lifeCycle.categoryPublicTree,
        addContentBreadCrum: state.content.addContentBreadCrum,
        editContent: state.content.editContent,
        editContentPage: state.content.editContentPage,
        reviewerList: state.content.reviewerList,
        contentsToReview: state.content.contentsToReview,
        authorizeContent: state.content.authorizeContent,
        practiceLabelName: state.lifeCycle.practiceLabelName,
        inDevelopmentArr: state.content.inDevelopmentArr,
        publishedArr: state.content.publishedArr,
        under_reviewArr: state.content.under_reviewArr,
        reviewByMeArr: state.content.reviewByMeArr,
        contentList: state.content.contentList,
        contentListData: state.content.contentListData,
        contentsToExport: state.content.contentsToExport,
        searchedCategory: state.content.searchedCategory,
        reviewRequestArr: state.content.reviewRequestArr,
        contentCountData: state.content.contentCountData,
        redirectFromDashboard: state.home.redirectFromDashboard,
        activePage: state.content.activePage,
        contentStatus: state.content.contentStatus,
        contentSearchOn: state.content.contentSearchOn,
        searchQuery: state.content.searchQuery,
        importContentLoader: state.loading.effects.content.importContents && state.loading.models.content,
        exportContentLoader: state.loading.effects.content.getMyContenetsToExport && state.loading.models.content,
        currentPathValue: state.content.currentPathValue,
        splitAtSize: state.content.splitAtSize,
        resourcePaneFlag: state.content.resourcePaneFlag,
        setUniqueId: state.lifeCycle.setUniqueId,
        collapsedResourcePaneIndexTemp: state.app.collapsedResourcePaneIndexTemp,
        componentDesignerDimension: state.initiatives.componentDesignerDimension,
        selectedContent: state.content.selectedContent,
        contentListDataforCSV: state.content.contentListDataforCSV,
        selectedAccount: state.app.selectedAccount,
        tableFilterQuery: state.app.tableFilterQuery,
        publicCategoryList: state.app.publicCategoryList,
        selectedBaseCategory: state.app.selectedBaseCategory,
        selectedCategory: state.app.selectedCategory,
        selectedSubCategory: state.app.selectedSubCategory,
        selectedContentScope: state.app.selectedContentScope,
        contentPath: state.app.contentPath,
        categoryTreeList: state.categories.categoryTreeList,
        contentLoading:state.content.contentLoading,
        treeNodeSelected:state.content.treeNodeSelected,
        selectedTreeId:state.content.selectedTreeId,
        cancelFlag:state.content.cancelFlag,
        contentComponentMounted:state.content.contentComponentMounted
    };
}

const connectedContentManager = withRouter(connect(mapStateToProps)(ContentManager));

export { connectedContentManager as ContentManager }; 